export const environment = {
  production: true,

  timeout: 60000,
  defaultPositionQuery: ['OPEN'],
};
